import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const ComoFuncionaPage = () => {
  const steps = [
    {
      number: 1,
      icon: 'ri-whatsapp-line',
      title: 'Entre em Contato',
      description: 'Fale conosco pelo WhatsApp e conte sua ideia. Nossa equipe está pronta para atender você e entender suas necessidades.',
      details: [
        'Atendimento rápido e personalizado',
        'Tire todas as suas dúvidas',
        'Receba orientações sobre produtos',
        'Solicite orçamento sem compromisso',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20customer%20service%20representative%20using%20smartphone%20whatsapp%20for%20business%20communication%20on%20clean%20simple%20white%20background%20bright%20commercial%20photography&width=600&height=400&seq=step1&orientation=landscape',
    },
    {
      number: 2,
      icon: 'ri-palette-line',
      title: 'Criação do Design',
      description: 'Nossa equipe de designers desenvolve o layout personalizado conforme suas especificações e identidade visual.',
      details: [
        'Design exclusivo e profissional',
        'Revisões até aprovação final',
        'Mockups para visualização',
        'Sugestões criativas da equipe',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20graphic%20designer%20working%20on%20computer%20creating%20custom%20designs%20for%20sublimation%20printing%20on%20clean%20simple%20white%20background%20bright%20commercial%20photography&width=600&height=400&seq=step2&orientation=landscape',
    },
    {
      number: 3,
      icon: 'ri-printer-line',
      title: 'Produção',
      description: 'Iniciamos a produção com sublimação de alta qualidade, garantindo cores vibrantes e durabilidade excepcional.',
      details: [
        'Equipamentos de última geração',
        'Materiais de alta qualidade',
        'Controle de qualidade rigoroso',
        'Processo profissional certificado',
      ],
      image: 'https://readdy.ai/api/search-image?query=modern%20professional%20sublimation%20printing%20machine%20in%20production%20with%20colorful%20products%20being%20manufactured%20on%20clean%20simple%20white%20background%20bright%20commercial%20photography&width=600&height=400&seq=step3&orientation=landscape',
    },
    {
      number: 4,
      icon: 'ri-truck-line',
      title: 'Entrega',
      description: 'Seus produtos são cuidadosamente embalados e entregues no prazo combinado, prontos para uso ou distribuição.',
      details: [
        'Embalagem profissional',
        'Entrega no prazo',
        'Rastreamento disponível',
        'Garantia de qualidade',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20delivery%20service%20person%20with%20packages%20boxes%20of%20personalized%20products%20on%20clean%20simple%20white%20background%20bright%20commercial%20photography&width=600&height=400&seq=step4&orientation=landscape',
    },
  ];

  const faqs = [
    {
      question: 'Qual o prazo de produção?',
      answer: 'O prazo varia de acordo com o produto e quantidade. Em média, trabalhamos com 5 a 10 dias úteis após aprovação do design.',
    },
    {
      question: 'Qual a quantidade mínima?',
      answer: 'Não trabalhamos com quantidade mínima! Atendemos desde 1 unidade até grandes volumes corporativos.',
    },
    {
      question: 'Vocês fazem o design?',
      answer: 'Sim! Nossa equipe de designers cria layouts personalizados ou adapta sua arte para sublimação.',
    },
    {
      question: 'Como funciona o pagamento?',
      answer: 'Aceitamos diversas formas de pagamento: PIX, cartão de crédito, débito e transferência bancária.',
    },
    {
      question: 'Fazem entrega?',
      answer: 'Sim! Realizamos entregas em todo o Rio de Janeiro e enviamos para todo o Brasil via correios ou transportadora.',
    },
    {
      question: 'Posso ver uma amostra antes?',
      answer: 'Sim! Enviamos mockups digitais para aprovação. Para grandes volumes, podemos produzir uma amostra física.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-primary to-primary-dark text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="font-montserrat font-extrabold text-5xl md:text-6xl mb-6">
              Como Funciona
            </h1>
            <p className="text-xl font-poppins text-white/90 max-w-3xl mx-auto">
              Processo simples e transparente do primeiro contato até a entrega dos seus produtos personalizados
            </p>
          </div>
        </div>
      </section>

      {/* Steps Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } items-center gap-12 mb-20 last:mb-0`}
            >
              {/* Image */}
              <div className="lg:w-1/2">
                <div className="relative">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-[400px] object-cover rounded-3xl shadow-xl"
                  />
                  <div className="absolute -top-6 -left-6 w-20 h-20 rounded-full bg-gradient-to-br from-accent-red to-accent-yellow flex items-center justify-center shadow-2xl">
                    <span className="font-montserrat font-bold text-4xl text-white">
                      {step.number}
                    </span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-1/2">
                <div className="w-16 h-16 flex items-center justify-center bg-accent-yellow/20 rounded-2xl mb-6">
                  <i className={`${step.icon} text-4xl text-accent-red`}></i>
                </div>
                <h2 className="font-montserrat font-bold text-4xl text-primary mb-4">
                  {step.title}
                </h2>
                <p className="text-gray-700 text-lg font-poppins leading-relaxed mb-6">
                  {step.description}
                </p>
                <ul className="space-y-3">
                  {step.details.map((detail, idx) => (
                    <li key={idx} className="flex items-center gap-3">
                      <i className="ri-check-line text-accent-yellow text-2xl"></i>
                      <span className="text-gray-700 font-poppins">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-montserrat font-bold text-4xl text-primary mb-4">
              Linha do Tempo do Projeto
            </h2>
            <p className="text-gray-600 text-lg font-poppins">
              Acompanhe cada etapa do seu pedido
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-accent-yellow hidden lg:block"></div>

            {/* Timeline Items */}
            <div className="space-y-12">
              {[
                { day: 'Dia 1', title: 'Contato Inicial', desc: 'Primeiro contato e briefing' },
                { day: 'Dia 2-3', title: 'Desenvolvimento', desc: 'Criação do design personalizado' },
                { day: 'Dia 4', title: 'Aprovação', desc: 'Revisão e aprovação final' },
                { day: 'Dia 5-8', title: 'Produção', desc: 'Fabricação dos produtos' },
                { day: 'Dia 9-10', title: 'Entrega', desc: 'Envio e recebimento' },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center gap-8 ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className={`lg:w-1/2 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                    <div className="bg-gray-50 rounded-2xl p-6 shadow-md">
                      <span className="text-accent-red font-poppins font-semibold text-sm">
                        {item.day}
                      </span>
                      <h3 className="font-montserrat font-bold text-2xl text-primary mt-2 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 font-poppins">{item.desc}</p>
                    </div>
                  </div>
                  <div className="hidden lg:flex w-12 h-12 items-center justify-center bg-accent-yellow rounded-full border-4 border-white shadow-lg z-10">
                    <i className="ri-check-line text-primary text-xl"></i>
                  </div>
                  <div className="hidden lg:block lg:w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-montserrat font-bold text-4xl text-primary mb-4">
              Perguntas Frequentes
            </h2>
            <p className="text-gray-600 text-lg font-poppins">
              Tire suas dúvidas sobre nossos serviços
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="bg-white rounded-2xl shadow-md overflow-hidden group"
              >
                <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                  <h3 className="font-poppins font-semibold text-lg text-primary pr-4">
                    {faq.question}
                  </h3>
                  <i className="ri-arrow-down-s-line text-2xl text-accent-red group-open:rotate-180 transition-transform flex-shrink-0"></i>
                </summary>
                <div className="px-6 pb-6">
                  <p className="text-gray-700 font-poppins leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl mb-6">
            Pronto para começar seu projeto?
          </h2>
          <p className="text-xl font-poppins text-white/90 mb-8">
            Entre em contato agora e receba seu orçamento personalizado em até 2 horas!
          </p>
          <a
            href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20da%20JR%20Gráfica%20e%20Sublimação."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-accent-yellow text-primary px-10 py-5 rounded-full font-poppins font-semibold hover:bg-accent-yellow/90 transition-all whitespace-nowrap cursor-pointer shadow-xl text-lg"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Iniciar Meu Pedido Agora
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ComoFuncionaPage;